import { render, staticRenderFns } from "./UpcomingSpinningSegment.vue?vue&type=template&id=50783bfb&scoped=true"
import script from "./UpcomingSpinningSegment.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpcomingSpinningSegment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UpcomingSpinningSegment.vue?vue&type=style&index=0&id=50783bfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50783bfb",
  null
  
)

export default component.exports